import React from 'react'
import styled from 'styled-components'
import { useLogic } from '~common/ui-logic/hooks/logic'
import { useAppContext } from '~/app-context'
import { GmailAccountSelectorLogic } from './logic'
import { Button } from '~common/components/button'
import DropdownMenu from '~common/components/dropdown-menu'
import { Icon } from '~common/components/icon'

export const GmailAccountSelector: React.FC = () => {
    const appContext = useAppContext()
    const { logic, state } = useLogic(GmailAccountSelectorLogic, {
        ...appContext,
    })

    const accountItems = state.googleAccounts.map((email) => {
        const profilePic = state.profilePictures[email]
        return {
            id: email,
            label: email,
            icon: profilePic ? (
                <ProfileImage
                    src={`data:image/jpeg;base64,${profilePic}`}
                    alt="Profile"
                />
            ) : (
                'gmail'
            ),
            // Disable current user for now as it is already selected
            // or handle switching if needed (logic not implemented yet)
            disabled: email === state.currentUserEmail,
            onClick: () => logic.handleAccountSelect(email),
        }
    })

    const dropdownItems = [
        ...accountItems,
        {
            id: 'add-account',
            label: 'Add new Inbox',
            icon: 'plus',
            onClick: logic.handleAddNewInbox,
        },
    ]

    const currentProfilePic = state.currentUserEmail
        ? state.profilePictures[state.currentUserEmail]
        : null

    return (
        <DropdownMenu
            trigger={
                <Button
                    label={state.currentUserEmail}
                    icon={
                        currentProfilePic ? (
                            <ProfileImage
                                src={`data:image/jpeg;base64,${currentProfilePic}`}
                                alt="Profile"
                            />
                        ) : (
                            'gmail'
                        )
                    }
                    variant="secondary"
                    size="medium"
                    height="40px"
                />
            }
            items={dropdownItems}
        />
    )
}

const ProfileImage = styled.img`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
`
